import { useEffect } from "react";
import AddNotes from "./components/AddNotes";
import StatusIssue from "./components/StatusIssue";
import StatusNotes from "./components/StatusNotes";
import Incident from "./components/Incident";
import decode from 'jwt-decode'

const CommentForm = (props) => {
  const {
    addComment,
    fetchAPI,
    issues,
    privilege,
    MultiHandleOptionsTask,
    stateOption,
    incidentOption,
    sendMessages
  } = props;
  const decoded = decode(localStorage.getItem("token"))

  useEffect(() => {
    if (decoded && issues?.idlayanan) {
      MultiHandleOptionsTask({
        params: {
          id: decoded?.id,
          idlayanan: issues?.idlayanan,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [issues?.idlayanan]);


  return (
    <>
      {privilege?.add_notes && (
        <AddNotes addComment={addComment} fetchAPI={fetchAPI} issues={issues} stateOption={stateOption} />
      )}
      {issues?.idkategori === 99999 && privilege?.add_notes && (
        <Incident fetchAPI={fetchAPI} issues={issues} incidentOption={incidentOption} MultiHandleOptionsTask={MultiHandleOptionsTask} />
      )}
      {privilege?.status_issue && (
        <>
          <StatusIssue fetchAPI={fetchAPI} issues={issues} stateOption={stateOption} />
          <StatusNotes fetchAPI={fetchAPI} issues={issues} stateOption={stateOption} sendMessages={sendMessages} />
        </>
      )}
      {!privilege?.status_issue && privilege?.status_notes && (
        <StatusNotes fetchAPI={fetchAPI} issues={issues} stateOption={stateOption} sendMessages={sendMessages} />
      )}
    </>
  );
};

export default CommentForm;
